import { render } from "./TransferCard.vue?vue&type=template&id=135e0d9c"
import script from "./TransferCard.vue?vue&type=script&lang=js"
export * from "./TransferCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__